<template lang="pug">
.asdf
    div hahaha
</template>
<script>
import $ from "jquery";
export default {
    name: 'UsedcarsView',
    data() {
        return {
        }
    },
    beforeMount: function () {
        $('#previewImage').carousel();
        console.log('asdfasdf');

        $('.js-thumb').find('.js-img-0').addClass('active');

        $('#previewImage').on('slide.bs.carousel', function (data) {
            // do something...
            console.log(data.from , data.to );
            $('.js-thumb').find('img').removeClass('active');
            $('.js-thumb').find('.js-img-' + data.to).addClass('active');
        })

        $('.js-thumb img').click(function(){
            var n = $(this).attr('data-key');
            $('#previewImage').carousel(parseInt(n));
        });
    },
}
</script>


// WEBPACK FOOTER //
// src/modules/UsedcarsView.vue